"use strict";
/* tslint:disable */
/**
 * File was automatically generated using json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND.
 * Instead, modify the source file /oada/websockets/request.schema.json of @oada/formats
 * and run `$ yarn build` to regenerate this file.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.assert = exports.is = exports.$id = void 0;
// Import packed validation function
const request_validate_js_1 = __importDefault(require("./request-validate.js"));
/**
 * $id of the source schema
 * @see {@link https://formats.openag.io/oada/websockets/request.schema.json}
 */
exports.$id = "https://formats.openag.io/oada/websockets/request.schema.json";
/**
 * Returns true if val is a @type Request, false otherwise
 */
function is(val) {
    return request_validate_js_1.default(val);
}
exports.is = is;
/**
 * Asserts that val is a @type Request
 */
function assert(val) {
    if (!request_validate_js_1.default(val)) {
        throw {
            errors: request_validate_js_1.default.errors,
            input: val
        };
    }
}
exports.assert = assert;
//# sourceMappingURL=request.js.map